import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { LocalStorageService } from '../local-storage/local-storage.service';
import { UserModel } from '../../models/user.model';
import { DeviceService } from '../device/device.service';
import { AppearanceService } from '../appearance/appearance.service';
import { Constants } from '../../constants/constants';
import { ClientService } from '../client/client.service';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ReportService 
{


  constructor(private apiService: APIService, private localStorageService: LocalStorageService,
    private appearanceService: AppearanceService, private clientService: ClientService) 
  {
    this.initService();
  }


  initService()
  {
    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
  
  }


  // API Calls -------------------------------------------------------------------------


  public getReportData(payload): any 
  { 
    return this.apiService.getReportData(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public setupReport(payload): any 
  { 
    return this.apiService.setupReport(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getReportHeaders(payload): any 
  { 
    return this.apiService.getReportHeaders(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateReport(payload): any 
  { 
    return this.apiService.updateReport(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createReport(payload): any 
  { 
    return this.apiService.createReport(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public downloadReport(payload): any 
  { 
    return this.apiService.downloadReport(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteReport(payload): any 
  { 
    return this.apiService.deleteReport(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public getStlPresetsForReport(payload): any 
  { 
    return this.apiService.getStlPresetsForReport(payload).pipe(map((response: any) => {

        if (response.Success)
        {
        }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createDatePartOfQuery(dateRangeChoice, dateColumn, fixedAmount, fixedInterval)
  {
    var returnData = {
      queryString: null,
      errorMessage: null
    };

    switch(dateRangeChoice)
    {
      case 'today':
        returnData.queryString = "AND DATE(" + dateColumn + ") = CURDATE() ";
        break;

      case 'yesterday':
        break;

      case 'thisweek':
        returnData.queryString = "AND YEARWEEK(" + dateColumn + ", 1) = YEARWEEK(CURDATE(), 1) ";
        break;

      case 'lastweek':
        returnData.queryString = "AND YEARWEEK(" + dateColumn + ", 1) = YEARWEEK(CURDATE() - INTERVAL 1 WEEK, 1) ";
        break;

      case 'thismonth':
        returnData.queryString = "AND YEAR(" + dateColumn + ") = YEAR(CURRENT_DATE) AND MONTH(" + dateColumn + ") = MONTH(CURDATE()) ";
        break;

      case 'lastmonth':
        returnData.queryString = "AND YEAR(" + dateColumn + ") = YEAR(CURRENT_DATE - INTERVAL 1 MONTH) AND MONTH(" + dateColumn + ") = MONTH(CURRENT_DATE - INTERVAL 1 MONTH) ";
        break;

      case 'alltime':
        break;

      case 'fixedrange':

        if (!fixedAmount)
        {
          returnData.errorMessage = "Last value is missing.";
        }

        if (fixedAmount < 2)
        {
          returnData.errorMessage = "Last value must be greater than 1.";
        }

        if (fixedInterval == "week")
        {
          returnData.queryString = " AND " + dateColumn + " BETWEEN CURDATE() - INTERVAL " + fixedAmount + " WEEK AND CURDATE()";
        }
        else if (fixedInterval == "month")
        {
          returnData.queryString = " AND " + dateColumn + " BETWEEN CURDATE() - INTERVAL " + fixedAmount + " MONTH AND CURDATE()";
        }
        else
        {
          returnData.errorMessage = "Interval is missing.";
        }

        break;

      case 'setrange':
        /*
        if ($scope.SelectedReport.StartDateTime)
        {
          returnData.queryString = "AND " + dateColumn + " BETWEEN '" + $scope.SelectedReport.StartDateTime + " 00:00:00' ";
        }
        else
        {
          returnData.errorMessage = "Start Date is missing.";
        }

        if ($scope.SelectedReport.EndDateTime)
        {
          returnData.queryString = " AND '" + $scope.SelectedReport.EndDateTime + " 23:59:59' ";
        }
        else
        {
          returnData.errorMessage = "End Date is missing.";
        }

        if (moment($scope.SelectedReport.EndDateTime).isBefore(moment($scope.SelectedReport.StartDateTime)))
        {
          returnData.errorMessage = "End Date must be after Start Date.";
        }
        */
        break;

      }

    return returnData;
  }
}
